import React, { Component } from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import tntMuiTheme from '../../theme/tntMuiTheme';
import AuthContainer from './components/AuthContainer';

class App extends Component {
  constructor(props) {
    super(props)
    // Needed for onTouchTap in Material-UI Components
    // http://stackoverflow.com/a/34015469/988941
    injectTapEventPlugin();
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(tntMuiTheme)}>
        <AuthContainer />
      </MuiThemeProvider>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/layout/App/App.js